import { render, staticRenderFns } from "./RoomInfo.vue?vue&type=template&id=4ebed841&scoped=true"
import script from "./RoomInfo.vue?vue&type=script&lang=js"
export * from "./RoomInfo.vue?vue&type=script&lang=js"
import style0 from "./RoomInfo.vue?vue&type=style&index=0&id=4ebed841&prod&lang=css"
import style1 from "./RoomInfo.vue?vue&type=style&index=1&id=4ebed841&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebed841",
  null
  
)

export default component.exports